import { render, staticRenderFns } from "./AscTermsAndConditionsContainer.vue?vue&type=template&id=1066306e&"
import script from "./AscTermsAndConditionsContainer.vue?vue&type=script&lang=js&"
export * from "./AscTermsAndConditionsContainer.vue?vue&type=script&lang=js&"
import style0 from "./AscTermsAndConditionsContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
